import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoListNumbers = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ListNumbers</title>
    <path
      d="M12.839 8.9h14.117M12.84 16.9h9.942"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m6.956 9.343-1.135 1-.68-.784L6.988 8h1.12v5.664H6.956v-4.32ZM5.045 24.703l2.2-1.976c.111-.101.223-.216.335-.344a.66.66 0 0 0 .168-.448.533.533 0 0 0-.208-.448.753.753 0 0 0-.488-.168c-.224 0-.4.07-.527.208a.85.85 0 0 0-.208.512l-1.2-.088a1.92 1.92 0 0 1 .184-.76c.106-.218.248-.4.424-.544.176-.144.38-.25.616-.32.24-.074.498-.112.775-.112.256 0 .496.038.72.112.224.07.419.176.584.32.166.139.294.315.384.528.096.214.144.462.144.744 0 .182-.018.347-.056.496a1.738 1.738 0 0 1-.392.728c-.09.101-.189.2-.296.296l-1.72 1.48h2.512v1.056H5.045v-1.272Z"
      fill="currentColor"
    />
    <path d="M12.84 24.9h12.818" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgIcoListNumbers;
